export default __webpack_public_path__ + "static/media/11-56.db040506.png";